import { Injectable, signal } from '@angular/core';
import { ModalType } from '../ui/types/modal-type.type';
import { ModalConfig } from '../ui/types/modal-config.type';


@Injectable({
  providedIn: 'root'
})
export class ModalService {
  modalVisible = signal<boolean>(false);
  title = signal('');
  message = signal('');
  imageUrl = signal('');
  btnCancelar = signal(false);
  continueButtonText = signal('Continuar');
  modalType = signal<ModalType>('success')
  iconClass= signal<string>('')
  useIcon = signal<boolean>(false);
  showToastOnConfirm = signal(false);

  onConfirm?: () => void;

  constructor() { }

  showModal(config: ModalConfig) {
    this.title.set(config.title);
    this.message.set(config.message);
    this.imageUrl.set(config.imageUrl);
    this.btnCancelar.set(config.btnCancelar);
    this.modalVisible.set(true);
    this.onConfirm = config.onConfirm;
    this.continueButtonText.set(config.continueButtonText ?? 'Continuar');
    this.modalType.set(config.modalType ?? 'success');
    this.iconClass.set(config.iconClass ?? '');
    this.useIcon.set(config.useIcon ?? false);
    this.showToastOnConfirm.set(config.showToastOnConfirm ?? false);
}

  openModal(){
    this.modalVisible.set(true);
  }

  closeModal(){
    this.modalVisible.set(false);
  }
}
